import { decimalToPercentage, numberToText } from "./transformators";

export const setInsuranceVars = (inco, globalparams, setValues, setData) => {
  const insuranceRates = {
    DAP: { rate: globalparams?.DAPInsuranceRate, factor: globalparams?.CIPInsuranceFactor },
    CIP: { rate: globalparams?.CIPInsuranceRate, factor: globalparams?.CIPInsuranceFactor },
    CIF: { rate: globalparams?.CIPInsuranceRate, factor: globalparams?.CIPInsuranceFactor },
    CPT: { rate: globalparams?.CPTInsuranceRate, factor: globalparams?.CIPInsuranceFactor },
    CFR: { rate: globalparams?.CPTInsuranceRate, factor: globalparams?.CIPInsuranceFactor },
  };
  const { rate, factor } = insuranceRates[inco] || { rate: 0, factor: 0 };
  setValues((prev) => ({
    ...prev,
    insurancerate: decimalToPercentage(rate),
    insurancefactor: numberToText(factor),
  }));
  setData((prev) => ({
    ...prev,
    insurancerate: rate,
    insurancefactor: factor,
  }));
};

// export const sumvalues = (...args) => {
//   var s = 0;
//   for (const i in args) {
//     s += Number(args[i]);
//   }
//   return new Promise((resolve, reject) => {
//     resolve(s);
//   });
// };
export const sumvalues = async (...args) => {
  return args.reduce((acc, val) => acc + (Number(val) || 0), 0);
};
export const subvalues = (a, b) => {
  return new Promise((resolve, reject) => {
    resolve(a - b);
  });
};
// export const multiplyvalues = (...args) => {
//   var p = 1;
//   for (const i in args) {
//     p *= Number(args[i]);
//   }
//   return new Promise((resolve, reject) => {
//     resolve(p);
//   });
// };
export const multiplyvalues = async (...args) => {
  return args.reduce((product, val) => product * (Number(val) || 0), 1);
};

export const dividevalues = (a, b) => {
  return new Promise((resolve, reject) => {
    if (b) {
      resolve(a / b);
    } else {
      resolve(0);
    }
  });
};

export const interestcostcalc = (tcost, ppayterms, spayterms, prate, srate, salesprice) => {
  return new Promise((resolve, reject) => {
    var intcost = 0;
    ppayterms.forEach((item) => {
      spayterms.forEach((item1) => {
        if (item.payTypeID === 3) {
          intcost += (item.portion * prate * item.termdays * tcost) / 360;
        }
        if (item1.payTypeID !== 3) {
          intcost += (item1.portion * srate * item1.termdays * salesprice) / 360;
        }
        if (item.payTypeID !== 3) {
          intcost -= (item.portion * prate * item.termdays * tcost) / 360;
        }
        if (item1.payTypeID === 3) {
          intcost -= (item1.portion * srate * item1.termdays * salesprice) / 360;
        }
      });
    });
    resolve(intcost > 0 ? intcost : 0);
  });
};

export const storagepmtcalc = (stgdays, stgfix, stgvar, qty, qtypallets, accrualpd) => {
  return new Promise((resolve, reject) => {
    qty > 0 && accrualpd > 0
      ? resolve(stgfix / qty + (Math.floor(stgdays / accrualpd) * stgvar * qtypallets) / qty)
      : resolve(0);
  });
};
